import Entretiens from "./Entretiens"
import Interventions from "./Interventions"

export default ({entretiens_count = 0, interventions_count = 0}) => {
  return (
    <div>
      { entretiens_count > 0 && 
          <div id="entretiens"><Entretiens /></div>
      }
      { interventions_count > 0 && 
          <div id="interventions"><Interventions /></div>
      }
    </div>
  )
}